(function($) {

    // Get height of viewport
    heroHeight = function() {

        var viewportHeight = $(window).height();
        var heroBlock = $('.image-fullscreen .bg-image');

        heroBlock.css('height', viewportHeight);

    };
    heroHeight();

    $(window).resize(function() {
        heroHeight();
    });

}(jQuery));
